import { render, staticRenderFns } from "./ActualizacionArticulos.vue?vue&type=template&id=172addfc&"
import script from "./ActualizacionArticulos.vue?vue&type=script&lang=js&"
export * from "./ActualizacionArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports